<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Client Code</th>
              <th class="text-left">Type</th>
              <th class="text-left">Name</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="client in clients"
              :key="client.clientId"
              @click="selectClient(client)">
              <td>
                <a @click.stop="goToClient(client.clientUri)">{{ client.clientCode }}</a>
              </td>
              <td>{{ client.protocolType }}</td>
              <td>{{ client.clientName }}</td>
              <td>
                <ul>
                  <li v-for="grantType in resolveGrantTypes(client.clientGrantTypes)" :key="grantType">
                    {{ grantType }}
                    <v-icon
                      v-if="grantType === 'client_credentials'"
                      @click.stop="showSecrets(client)">
                      mdi-key
                    </v-icon>
                  </li>

                </ul>
              </td>
              <td>
                <v-icon @click.stop="showDeleteClient(client.clientId)">
                  mdi-delete-forever
                </v-icon>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-dialog
          max-width="750"
          persistent
          v-model="clientDialog">
          <v-card class="pa-5">
            <detail
              v-if="selectedClient"
              :client="selectedClient">
            </detail>
             <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="cancelDialog">
                Cancel
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="updateClient">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <secrets :showDialog="showSecretsDialog"
          @cancelDialog="cancelSecretsDialog"
          @saveSecret="saveSecret">
        </secrets>
        <delete-dialog
          :showDialog="deleteClientDialog"
          @deleteClient="deleteClient"
          @cancelDialog="cancelDeleteDialog">
        </delete-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Detail from '../components/Clients/Detail'
import DeleteDialog from '../components/Clients/DeleteDialog'
import Secrets from '../components/Clients/Secrets'

export default {
  components: {
    Detail,
    DeleteDialog,
    Secrets
  },
  data () {
    return {
      clients: [],
      clientDialog: false,
      deleteClientDialog: false,
      showSecretsDialog: false,
      deleteClientId: null,
      selectedClient: null
    }
  },
  methods: {
    showSecrets (e) {
      this.selectedClient = e
      this.showSecretsDialog = true
    },
    cancelSecretsDialog () {
      this.selectedClient = null
      this.showSecretsDialog = false
    },
    saveSecret (e) {
      const baseURI = '/client/updateSecret'

      this.$http.post(baseURI, {
        clientId: this.selectedClient.clientId,
        secret: e
      })
      .then(result => {
        if (result) {
          this.getClients()
          this.showSecretsDialog = false
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    getClients () {
      const baseURI = '/client/get'

      this.$http.get(baseURI)
      .then(result => {
        this.clients = result.data.clients
      })
      .catch(error => {
        console.log(error)
      })
    },
    updateClient () {
      const baseURI = '/client/update'

      this.$http.post(baseURI, this.selectedClient )
      .then(result => {
        if (result) {
          this.getClients()
          this.clientDialog = false
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    deleteClient () {
      const baseURI = '/client/delete'

      this.$http.post(baseURI, { clientId: this.deleteClientId } )
      .then(result => {
        if (result) {
          this.getClients()
          this.cancelDeleteDialog()
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    showDeleteClient (e) {
      this.deleteClientDialog = true
      this.deleteClientId = e
    },
    cancelDeleteDialog () {
      this.deleteClientDialog = false
      this.deleteClientId = null
    },
    resolveGrantTypes (grantTypes) {
      return grantTypes.map(c => {
        return c.grantType
      })
    },
    selectClient (e) {
      this.selectedClient = e
      this.clientDialog = true
    },
    goToClient (uri) {
      if (uri) window.open(uri, '_blank')
    },
    cancelDialog () {
      this.clientDialog = false
    },
    newRedirectUri () {
      this.selectedClient.clientRedirectUris.push({
        redirectUri: null,
        clientId: this.selectedClient.clientId
      })
    },
    updateRedirectUri(e) {
      this.selectedClient.clientRedirectUris[e.i].redirectUri = e.e
    },
    newPostLogoutRedirectUri () {
      this.selectedClient.clientPostLogoutRedirectUris.push({postLogoutRedirectUri: null})
    },
    updatePostRedirectLogoutUri(e) {
      this.selectedClient.clientPostLogoutRedirectUris[e.i].postLogoutRedirectUri = e.e
    },
    updateGrantType(e) {
      this.selectedClient.clientGrantTypes[e.i].grantType = e.e
    },
    cancelRedirectUri (i) {
      this.selectedClient.clientRedirectUris.splice(i, 1)
    },
    cancelPostLogoutRedirectUri (i) {
      this.selectedClient.clientPostLogoutRedirectUris.splice(i, 1)
    },
    saveRedirectUri (i) {
      const baseURI = '/client/updateRedirectUri'

      this.$http.post(baseURI, this.selectedClient.clientRedirectUris[i] )
      .then(result => {
        if (result) {
          this.clients = []
          this.getClients()
          this.clientDialog = false
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    deleteRedirectUri (i) {
      const baseURI = '/client/deleteRedirectUri'

      this.$http.post(baseURI, { clientRedirectUrisId: i })
      .then(result => {
        if (result) {
          this.clients = []
          this.getClients()
          this.clientDialog = false
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    saveGrantType (i) {
      const baseURI = '/client/updateGrantType'

      this.$http.post(baseURI, this.selectedClient.clientGrantTypes[i] )
      .then(result => {
        if (result) {
          this.clients = []
          this.getClients()
          this.clientDialog = false
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
  },
  computed: {
  },
  created () {
    this.getClients()
    this.$eventHub.$on('newRedirectUri', this.newRedirectUri)
    this.$eventHub.$on('updateRedirectUri', this.updateRedirectUri)
    this.$eventHub.$on('cancelRedirectUri', this.cancelRedirectUri)
    this.$eventHub.$on('saveRedirectUri', this.saveRedirectUri)
    this.$eventHub.$on('newPostLogoutRedirectUri', this.newPostLogoutRedirectUri)
    this.$eventHub.$on('updatePostLogoutRedirectUri', this.updatePostRedirectLogoutUri)
    this.$eventHub.$on('cancelPostLogoutRedirectUri', this.cancelPostLogoutRedirectUri)
    this.$eventHub.$on('savePostLogoutRedirectUri', this.savePostLogoutRedirectUri)
    this.$eventHub.$on('updateGrantType', this.updateGrantType)
    this.$eventHub.$on('saveGrantType', this.saveGrantType)
    this.$eventHub.$on('deleteRedirectUri', this.deleteRedirectUri)
  },
  beforeDestroy () {
    this.$eventHub.$off('newRedirectUri')
    this.$eventHub.$off('updateRedirectUri')
    this.$eventHub.$off('cancelRedirectUri')
    this.$eventHub.$off('saveRedirectUri')
    this.$eventHub.$off('newPostLogoutRedirectUri')
    this.$eventHub.$off('updatePostLogoutRedirectUri')
    this.$eventHub.$off('cancelPostLogoutRedirectUri')
    this.$eventHub.$off('savePostLogoutRedirectUri')
    this.$eventHub.$off('updateGrantType')
    this.$eventHub.$off('saveGrantType')
    this.$eventHub.$off('deleteRedirectUri')
  }
}
</script>
